"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ErrorButton = void 0;
var _mui = require("@ori-ui/mui");
var _react = require("react");
var _internals = require("../../internals");
var _styled = require("./styled");
var _jsxRuntime = require("react/jsx-runtime");
const ErrorButton = ({
  text
}) => {
  const targetUrl = (0, _react.useRef)((0, _internals.getTargetUrl)());
  const navigate = (0, _react.useCallback)(() => {
    // check if we are an iframe
    if (window.self === window.top) {
      window.location.href = targetUrl.current;
    } else {
      window.parent.location.href = targetUrl.current;
    }
  }, [targetUrl]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Box, {
    sx: {
      justifyContent: 'center'
    },
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styled.StyledButton, {
      id: "ui-error-page-back-button",
      variant: "contained",
      color: "primary",
      onClick: navigate,
      children: text
    })
  });
};
exports.ErrorButton = ErrorButton;
